import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { ButtonComponent, InputComponent, PasswordComponent } from '@app-ui';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  ApiService,
  BaseComponent,
  isSystemSuperAdminFromToken,
  ProfileService,
  StorageService,
  SYSTEM_SUPER_ADMIN_HOME,
} from '@app-utils';
import { AsyncPipe, NgIf } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import {
  catchError,
  finalize,
  map,
  switchMap,
  takeUntil,
  throwError,
} from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { ClientJS } from 'clientjs';
import detectIncognito from 'detectincognitojs';

/**
 * Login Component
 */
@Component({
  selector: 'auth-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    InputComponent,
    PasswordComponent,
    FormsModule,
    ReactiveFormsModule,
    AsyncPipe,
    RouterModule,
    TranslateModule,
    NgIf,
  ],
})
export class LoginComponent extends BaseComponent implements OnInit {
  private readonly _fb = inject(FormBuilder);
  private readonly _storage = inject(StorageService);
  private readonly _profile = inject(ProfileService);
  private readonly _router = inject(Router);
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _api = inject(ApiService);

  private readonly _client = new ClientJS();

  incognito = false;

  fg: FormGroup = this._fb.group({
    userName: [null, [Validators.required, Validators.email]],
    password: [null, [Validators.required, Validators.minLength(6)]],
    // userName: ['testaur@yopmail.com', [Validators.required, Validators.email]],
    // password: ['Admin@123456', [Validators.required, Validators.minLength(6)]],
  });

  ngOnInit(): void {
    detectIncognito().then((result) => {
      this.incognito = result.isPrivate;
    });
  }

  /**
   * Fired when user clicks login button
   */
  login(): void {
    if (this.fg.invalid) return;
    this.loading$.next(true);
    const { userName, password } = this.fg.value;
    this._api
      .login(
        userName.trim(),
        password.trim(),
        `dev-fp-id-${this._client.getFingerprint()}${this.incognito ? 'INC' : ''}`,
      )
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => this.loading$.next(false)),
        switchMap((tokenRes) => {
          this._storage.setAuthToken(tokenRes.data.token);

          return this._api.getUserLoginDetail().pipe(
            map((userRes) => {
              this._profile.setOrganizationList(
                userRes.data.organisation || [],
              );
              // this._profile.setOrganization(orgRes.data[0]);
              return userRes;
            }),
          );
        }),
        catchError((e) => {
          this._storage.removeAuthToken();
          return throwError(() => e);
        }),
      )
      .subscribe((res) => {
        this._profile.setProfile(res.data);
        const returnUrl =
          this._activatedRoute.snapshot.queryParamMap.get('returnUrl') || '';
        if (returnUrl) {
          return void this._router.navigateByUrl(returnUrl);
        }
        if (isSystemSuperAdminFromToken(this._storage)) {
          void this._router.navigateByUrl(SYSTEM_SUPER_ADMIN_HOME);
          return;
        }
        void this._router.navigate(['/']);
      });
    // setTimeout(() => {
    //   this._profile.setProfile({
    //     userId: 123,
    //     firstName: 'SOME_NAME',
    //     lastName: 'SOME_NAME_2',
    //     jobTitle: '',
    //     email: '',
    //     phone: 9898988989,
    //     country: '',
    //     language: '',
    //   });
    //   this.loading$.next(false);
    //   this._storage.setAuthToken('SOME_TOKEN');
    //   void this._router.navigate(['/']);
    // }, 2000);
  }

  // goToSignup(){
  //   this._router.navigate(['/auth/signup']);
  // }
}
